import InfantFruitsAndVegsProduct from 'models/InfantFruitsAndVegsProduct'
import React from 'react'
import ProductForm from 'views/shared/ProductForm'
import BrandSpecificProductDesc from 'views/shared/BrandSpecificProductDesc'
import InfantFruitsAndVegsPackage from './InfantFruitsAndVegsPackage'
import { packagingInitialState, brandNameOptions } from './constants'

const productOptions = {
  // eslint-disable-next-line react/display-name
  productDesc: () => (
    <BrandSpecificProductDesc initialBrandNameOptions={brandNameOptions} />
  ),
  packagingInfo: (
    <InfantFruitsAndVegsPackage
      model={InfantFruitsAndVegsProduct}
      packagingInitialState={packagingInitialState}
    />
  ),
  productTitle: 'Infant Fruits and Vegetables',
  model: InfantFruitsAndVegsProduct,
  validCategories: ['12'],
  validSubCategories: ['001', '002', '003', '101', '102', '103'],
}

const InfantFruitsAndVegs = () => <ProductForm product={productOptions} />

export default InfantFruitsAndVegs

export const getInfantFruitsAndVegsPackage = newProduct => {
  let newInfantFruitsAndVegsPackage = {
    UPC: newProduct.UPC,
    PackageType: newProduct.PackageType,
    PacketSize: newProduct.PacketSize,
    NoAdditionalIngredients: newProduct.NoAdditionalIngredients,
    Organic: newProduct.Organic,
    MultiPackageType: newProduct.MultiPackageType,
    ProductType: newProduct.ProductType,
  }
  if (newProduct.MultiPackageType === true) {
    newInfantFruitsAndVegsPackage.MultiPackageCount =
      newProduct.MultiPackageCount
  }
  return newInfantFruitsAndVegsPackage
}

export const updateInfantFruitsAndVegsPackage = newProduct => {
  let newInfantFruitsAndVegsPackage = {
    UPC: newProduct.UPC,
    PackageType: newProduct.PackageType,
    PacketSize: newProduct.PacketSize,
    NoAdditionalIngredients: newProduct.NoAdditionalIngredients,
    Organic: newProduct.Organic,
    MultiPackageType: newProduct.MultiPackageType,
    ProductType: newProduct.ProductType,
  }
  if (newProduct.MultiPackageType === true) {
    newInfantFruitsAndVegsPackage.MultiPackageCount =
      newProduct.MultiPackageCount
  }
  return newInfantFruitsAndVegsPackage
}
